<template>
    <div class="privacy-policy">
        <section class="section page-wrapper">
            <div class="section__content">
                <LoadingIndicator v-if="$fetchState.pending">
                    {{ $t('pages.privacy_policy.loading') }}
                </LoadingIndicator>

                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-else-if="userTerms.privacyPolicyContent"
                    class="privacy-policy__content cms-content"
                    v-html="userTerms.privacyPolicyContent"
                />
                <!-- eslint-enable vue/no-v-html -->

                <template v-else>
                    <h1 class="section__heading">
                        {{ $t('pages.privacy_policy.heading') }}
                    </h1>
                    <p>{{ $t('pages.privacy_policy.description') }}</p>

                    <a :href="userTerms.privacyPolicyFileUrl" target="_blank" class="section__external-link">
                        <svg-icon name="document" class="section__external-link-icon" />{{
                            userTerms.privacyPolicyTitle
                        }}
                    </a>
                </template>
            </div>
            <Contact />
        </section>
    </div>
</template>

<router>
{
    name: 'privacy-policy'
}
</router>

<script>
/**
 * @note The filename is prefixed with 'hc-' to workaround an issue where the
 *       JS chunk 'privacy-policy.js' is blocked by Adblocker browser extensions
 */

import { mapGetters } from 'vuex';
import { actionTypes as configActions } from '~/store/config';
import Contact from '~/components/sections/Contact.vue';
import LoadingIndicator from '~/components/LoadingIndicator.vue';

export default {
    components: {
        Contact,
        LoadingIndicator,
    },
    async fetch() {
        try {
            await this.$store.dispatch(configActions.FETCH_USER_TERMS);
        } catch (err) {
            this.$sentry.captureException(err);
        }
    },
    head() {
        return {
            title: this.$t('pages.privacy_policy.seo_title'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$t('pages.privacy_policy.seo_description'),
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['userTerms']),
    },
    nuxtI18n: {
        paths: {
            se: '/personuppgifter',
            'fi-sv': '/personuppgifter',
            en: '/privacy-policy',
            de: '/datenschutzbestimmungen',
            at: '/datenschutzbestimmungen',
            fi: '/henkilotiedot',
            no: '/personopplysninger',
            dk: '/privatlivspolitik',
            ch: '/datenschutzbestimmungen',
            fr: '/confidentialite',
        },
    },
};
</script>

<style lang="scss">
.privacy-policy {
    .section__content {
        max-width: 680px;
    }
}
</style>
